module.exports = __webpack_public_path__ + "static/media/summerGarden.c724bd0f.jpg";